import ArtifactGroupType from "../base/ArtifactGroupType";


const XocolatlDrinkingCup = {
  id: '148',
  name: 'Xocolatl Drinking Cup',
  groupIcon: 'UnderTheCeiba',
  type: ArtifactGroupType.UNDER_THE_CEIBA,
  icon: 'XocolatlDrinkingCup',
  power: 10
};

export default XocolatlDrinkingCup;
